import React from "react";
import { Button, Typography, useTheme } from "@ugc-ui/lego";
import { ErrorOrLoaderContainer } from "@common/components/Interests/Interests.styled";
import { useNavigate } from "react-router-dom";
import { Path } from "@common/consts/Path";

type Props = {
  message?: string;
};
export const ErrorToHome = ({ message }: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(Path.TO_HOME);
  };

  return (
    <ErrorOrLoaderContainer>
      <Typography color={theme.gray.a90}>
        {message || "Страница не найдена"}
      </Typography>
      <Button onClick={handleClick} fullWidth={false}>
        Вернуться на главную
      </Button>
    </ErrorOrLoaderContainer>
  );
};
